import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../../auth/service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import { InvoiceService } from "../../../invoice.service";
import { ICustomer } from "../../../../customer/customer.interface";
import { CustomerService } from "../../../../customer/customer.service";
import { ListService } from "../../../../../auth/service/list.service";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";

@Component({
  selector: "app-invoice-sended",
  templateUrl: "./invoice-sended.component.html"
})
export class InvoiceSendedComponent implements OnInit {
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public listElements: any[] = [];
  public filteredListElements: any[] = [];
  public filterStatus: string = "all";
  public customers: ICustomer[] = [];
  public filterCustomer: number = 0;
  credit_notes_types_ids = []

  invoiceSelectedId: number | null = null;
  sumTotalsAmount: number = 0;
  invoices_with_errors: number[] = []
  invoices_not_found: number[] = []
  invoices_duplicated: number[] = []

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    private _listService: ListService,
    public _invoiceService: InvoiceService,
    private _customerService: CustomerService,
    private http: HttpClient
  ) {
    this.contentHeader = {
      headerTitle: "MENU.INVOICES_SENDED",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.INVOICES",
            isLink: false
          },
          {
            name: "MENU.INVOICES_SENDED",
            isLink: false
          }
        ]
      }
    };
    this._utilService.disableAutoHideLoading()
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_invoice_sended")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.customers = await this._customerService.getCustomers();
    this._listService.getList("invoice_document_type").then((result: any) => {
      this.credit_notes_types_ids = result.filter((result: any) => result.other.credit_note).map((result: any) => result.id)
    });
    this.load();
  }

  load() {
    this._utilService.showLoading();
    this._invoiceService.getSended().subscribe((data) => {
      this.listElements = data.map((invoice) => {
        const parts = invoice.additional_data.split(";");
        const additional_data: any = {};
        parts.forEach(part => {
          const [_, key, value] = part.match(/\[DatiOrdineAcquisto\|(\w+)\|([^\]]+)]/);
          additional_data[key] = value;
        });
        invoice.order_number = additional_data.IdDocumento;

        return invoice;
      });
      this.filter();
      this._utilService.hideLoading();
    });
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  filter() {
    let items: any[] = this.listElements;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) =>
        (item.document_number||'').toLowerCase().includes(keywords) ||
        (item.order_number||'').toLowerCase().includes(keywords) ||
        (item.client && item.client.name && item.client.name.toLowerCase().includes(keywords)) ||
        (item.users_in_rows||[]).join(",").toLowerCase().includes(keywords) ||
        (item.products_in_rows||[]).join(",").toLowerCase().includes(keywords) ||
        (item.rows||[])[0]?.description?.toLowerCase().includes(keywords)
      );
    }

    if (this.filterStatus !== "all") {
      items = items.filter((item) => item.status === this.filterStatus);
    }

    if (this.filterCustomer > 0) {
      items = items.filter((item) => Number(item.client.id) === Number(this.filterCustomer));
    }

    items = items.map((item: any) => ({ ...item, document_number: item.document_number || item.id }));

    const invoicesAmount = items
      .filter((item: any) => !this.credit_notes_types_ids.includes(item.invoice_type.id))
      .map((item: any) => Number(item.total_amount)).reduce((sum: number, total: number) => Number(sum) + Number(total), 0);

    const creditNotesAmount = items
      .filter((item: any) => this.credit_notes_types_ids.includes(item.invoice_type.id))
      .map((item: any) => Number(item.total_amount)).reduce((sum: number, total: number) => Number(sum) + Number(total), 0);

    this.sumTotalsAmount = invoicesAmount - creditNotesAmount;

    this.filteredListElements = items;
    this._utilService.hideLoading()
  }

  syncInvoices(){
    this._utilService.showLoading()
    this.http.get('/invoice/update-status-from-esolver')
      .pipe(
        tap((result: {invoices_error: string[], invoices_not_found: string[], invoices_duplicated: string[], message: string}) => {
          this.invoices_with_errors = result.invoices_error.map((id) => Number(id));
          this.invoices_not_found = result.invoices_not_found.map((id: any) => Number(id));
          this.invoices_duplicated = result.invoices_duplicated.map((id: any) => Number(id));
        })
      )
      .subscribe(() => this.load())
  }

  setStatusNotProcessed(invoice_id: number) {
    this._utilService.showLoading();
    this._invoiceService.updateStatus([invoice_id], 'not_processed').subscribe(() => {
      this.load();
    }, async (error) => {
      console.error(error);
      await this._utilService.showSWALError({ text: "INVOICE_STATUS_UPDATE_ERROR" });
      this._utilService.hideLoading();
    });
  }
}
